var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"top_cts acc_menu",attrs:{"id":"how_to"}},[_c('Accordion',{attrs:{"title":"複眼経済塾のはじめかた","storageKey":"how_to_list"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.how_to_list)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }